import {IframeModalShellComponent} from '@app/_components/iframe-modal-shell/iframe-modal-shell.component';
import {FileBrowserComponent} from '@app/_components/file-browser/file-browser.component';
import {SettingsService} from '@app/services/settings.service';
import {NgZone, AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {
  configureWidgetTextEditorNamespace as configureSharedWidgetTextEditorNamespace,
  configureWidgetTextEditorOutput as configureSharedWidgetTextEditorOutput,
  WIDGET_HEADER_TEXT_EDITOR_CONFIG,
  WIDGET_TEXT_EDITOR_CONFIG
} from '@app/modules/shared/widget-text-editor-config';
import {GlobalWidgetService} from '@app/services/global-widget.service';
import {WidgetCustomizationAiModalComponent} from '@app/_components/widget-customization-ai/widget-customization-ai-modal.component';
import {WidgetCustomizationAiResult} from '@app/_components/widget-customization-ai/widget-customization-ai.types';
import {
  CampaignGetAll,
  getCampaignError,
  getCampaigns,
  getProject,
  getProjectError,
  getRegistrationPlatforms,
  getRegistrationPlatform,
  getVariableError,
  getVariables,
  getWidgetCustomScriptBody,
  getWidgetIntegrationBody,
  ICampaignState,
  IProjectState,
  IRegistrationPlatformState,
  ITemplateState,
  IVariableState,
  ProjectGet,
  ProjectUpdate,
  RegistrationPlatformList,
  VariableList,
  WidgetCustomScriptBody,
  WidgetIntegrationBody,
  getLoggedInUser,
  IAuthenticationState,
  ITemplateSectionState,
  getToken,
  getRegistrationPlatformWidgetGuideUrl,
  RegistrationPlatformWidgetGuideURL,
  RegistrationPlatformDelete,
  RegistrationPlatformUpdate,
  RegistrationPlatformGet,
  getRegistrationPlatformSuccessResponse,
  getProjectSuccessResponse,
  getWidgetIntegrationBodyError,
  WidgetAvatarTemplateListAll,
  getWidgetAvatarTemplates
} from '@app/stores';
import {ActivatedRoute} from '@angular/router';
import {select, Store} from '@ngrx/store';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {ToastrService} from 'ngx-toastr';
import {Campaign} from '@app/modules/shared/models';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {environment} from '@environments/environment';
import {Constants} from '@app/consts';
import {RegistrationPlatformService} from '@app/services/registration-platform.service';
import {EntityFormModalService} from '@app/_components/unified/entity-form-modal/entity-form-modal.service';
import Swal from 'sweetalert2';
import {WidgetAvatarTemplatesComponent} from '@app/modules/project/widget-avatar-templates/widget-avatar-templates.component';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';
// import html = CKEDITOR.ui.dialog.html;
import * as _ from 'lodash';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
// The Custom Script box is an <ace-editor> from ng2-ace-editor, which runs on its own bundled
// `brace` copy -- not the global ace-builds script. Without this import that copy has no
// javascript mode and fetches `/mode-javascript.js` from the site root at runtime (a 404 on
// every visit; the basePath set below only ever reached the global instance). Importing it
// bundles the mode instead, so there is no request to get wrong.
import 'brace/mode/javascript';

declare var ace: any;

const WIDGET_MEDIA_ADVANCED_DEFAULTS_SETTING_KEY = 'widget_media_advanced_defaults';

@Component({
  selector: 'app-widget-instructions',
  templateUrl: './widget-instructions.component.html',
  styleUrls: ['./widget-instructions.component.scss'],
  providers: [Constants]
})
export class WidgetInstructionsComponent implements OnInit, OnDestroy, AfterViewInit {
  aceEditorOptions: any = {maxLines: 1000};
  readonly widgetHeaderTextEditorConfig = WIDGET_HEADER_TEXT_EDITOR_CONFIG;
  readonly widgetTextEditorConfig = WIDGET_TEXT_EDITOR_CONFIG;
  globalWidget: any = null;
  readonly globalWidgetSettingKeys = [
    'active',
    'note',
    'whitelist_access',
    'auto_add_ip',
    'limit_access_ips',
    'language',
    'header_1',
    'header_2',
    'header_3',
    'promo_text',
    'open_message_text',
    'minimized_notification_message_disabled',
    'hide_when_closed',
    'minimized_notification_message',
    'user_agreement_checkbox_disabled',
    'show_preload',
    'display_mode',
    'display_mode_state',
    'linkedin_share_method',
    'tiktok_share_method',
    'theme_color_1',
    'theme_color_2',
    'theme_color_3',
    'theme_color_4',
    'theme_color_5',
    'theme_color_6',
    'theme_color_7',
    'theme_color_8',
    'theme_color_9',
    'theme_color_10',
    'theme_color_11',
    'font_face',
    'font_family',
    'font_by_language',
    'font_size',
    'show_widget_ui_customization_on_all_widgets',
    'enable_joined_influencer_cookie'
  ];
  projectMeta: any = {};
  project: any;
  variables = {};
  projectId;
  unsubscriber = new Subject();
  campaigns: Campaign[] = [];
  registrationPlatforms = [];
  public widgetIntegrationBody: any;
  public widgetCustomScriptBody: any;
  @ViewChild('editor') editor;
  ipLimitUrl = '';
  shareWidgetLinkUrl = '';
  widgetIntegrationUrl: SafeResourceUrl;
  widgetCustomizationCode: any = null;
  widgetCustomizationCss: any = null;
  widgetIntegrationGuide: any = null;
  currentUser: any;
  token = null;
  platformName = '';
  projectPlatformId: number;
  selectedPlatform: any;
  isWidgetSave = false;
  isResetSelectPlatform = false;
  projectRegistrationPlatformId: number = null;
  private widgetGuideUrl: string;
  selectedcampaign: any;
  selectedWidgetSupport = null;
  selectedSyncSupport = null;
  widgetSupportValues = [{id: 'basic', name: 'Minimum (Clients might need help and it may not always work)'},
    {id: 'full', name: 'Full (Clients can easily add without any help and works but there are workarounds)'},
    {id: 'ultimate', name: 'Ultimate (Clients can easily add without any help and works reliably)'}];
  defaultAvatarImage = 'https://snoball-dev.s3-accelerate.amazonaws.com/TiqzVPzCFnIRK8XPXCXLo5MsAZPgub.png';
  widgetAIAvatarTemplates = [];
  selectedWidgetAIAvatarTemplate = null;

  widgetBehaviorToggles = [
    { key: 'discover_form_fields_detect_first_fields', default: true, label: 'Registration forms: stop after the first matched field per type (reduces duplicate picks on complex forms)' },
    { key: 'discover_payment_form_fields_detect_first_fields', default: true, label: 'Payment forms: stop after the first matched field per type' },
    { key: 'discover_promotion_form_fields_detect_first_fields', default: true, label: 'Promotion forms: stop after the first matched field per type' },
    { key: 'discover_form_fields_only_if_visible', default: false, label: 'Registration: only detect fields that are visible on the page' },
    { key: 'discover_payment_form_fields_only_if_visible', default: false, label: 'Payment: only detect visible fields' },
    { key: 'discover_promotion_form_fields_only_if_visible', default: false, label: 'Promotion: only detect visible fields' },
    { key: 'convert_name_to_first_name_last_name', default: true, label: 'When only a full name is found, split it into first and last before registering' },
    { key: 'show_widget_only_if_trigger_container_is_visible', default: true, label: 'Only show the widget after the trigger container element is visible' },
  ];

  default_custom_fields = [
    { key: 'custom_message', label: 'Influencer Custom Message', value: '', required: false },
    { key: 'custom_1', label: 'Custom 1', value: '', required: false },
    { key: 'custom_2', label: 'Custom 2', value: '', required: false },
    { key: 'custom_3', label: 'Custom 3', value: '', required: false },
    { key: 'custom_4', label: 'Custom 4', value: '', required: false },
    { key: 'custom_5', label: 'Custom 5', value: '', required: false },
    { key: 'custom_6', label: 'Custom 6', value: '', required: false },
    { key: 'custom_7', label: 'Custom 7', value: '', required: false },
    { key: 'custom_8', label: 'Custom 8', value: '', required: false },
    { key: 'custom_9', label: 'Custom 9', value: '', required: false },
    { key: 'custom_10', label: 'Custom 10', value: '', required: false },
  ];
  constructor(
    private route: ActivatedRoute,
    private projectStore: Store<IProjectState>,
    private campaignStore: Store<ICampaignState>,
    private toastr: ToastrService,
    public constants: Constants,
    private authenticationStore: Store<IAuthenticationState>,
    private templateStore: Store<ITemplateState>,
    private registrationPlatformService: RegistrationPlatformService,
    private registrationPlatformStore: Store<IRegistrationPlatformState>,
    private variableStore: Store<IVariableState>,
    // private templateSectionStore: Store<ITemplateSectionState>,
    private readonly cdr: ChangeDetectorRef,
    private elRef: ElementRef,
    private _modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private settingsService: SettingsService,
    private ngZone: NgZone,
    private readonly entityFormModal: EntityFormModalService,
    private globalWidgetService: GlobalWidgetService,
  ) {
    ace.config.set('basePath', environment.frontUrl.replace('#', '') + 'assets/js/ace-modes');
    this.authenticationStore.pipe(select(getToken))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(newToken => {
        if (newToken) {
          this.token = newToken;
        }
      });
    this.route.params.subscribe(params => {
      if (params.projectId) {
        this.projectId = +params.projectId;
        this.loadProject(this.projectId);
      }
    });
  }

  ngOnInit(): void {
    window.addEventListener('message', this.handleFontBrowserMessage);
    this.subscribeToStore();
    this.loadWidgetAdvancedDefaultSettings();
    this.campaignStore.dispatch(CampaignGetAll({filter: {project_id: this.projectId}}));
    // this.variableStore.dispatch(VariableList({params: {}}));
    this.fetchWidgetAITemplates();
    this.getAllRegistrationPlatforms();
    this.loadGlobalWidget();
    setTimeout(() => {
      this.setWidgetCode();
    }, 500);
  }

  subscribeToStore() {
    this.widgetGuideUrl = null;
    this.authenticationStore.pipe(select(getLoggedInUser)).subscribe(user => {
        this.currentUser = user;
      }
    );
    this.campaignStore.pipe(select(getCampaignError))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(error => {
        if (error) {
          this.toastr.error(error, 'Error');
        }
      });
    this.campaignStore.pipe(select(getVariableError))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(error => {
        if (error) {
          this.toastr.error(error, 'Error');
        }
      });
    this.projectStore.pipe(select(getProjectError))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(error => {
        if (error) {
          this.toastr.error(error, 'Error');
        }
      });

    this.registrationPlatformStore.pipe(select(getRegistrationPlatform))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(registrationPlatform => {
        if (registrationPlatform) {
          this.getAllRegistrationPlatforms();
          if (registrationPlatform.widget_support) {
           this.projectMeta['platform_name_with_support'] = `${registrationPlatform.name} ${registrationPlatform.widget_support}`;
           this.projectMeta['registration_platform_id'] = registrationPlatform.id;
           this.selectedPlatform = registrationPlatform.id;
           this.setWidgetCode();
         }
        }
      });

    this.variableStore.pipe(select(getVariables))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(variables => {
        if (variables) {
          const result = [];
          Object.entries(variables).forEach(([key, value]) => {
            if (value.hasOwnProperty('group') && value['group']) {
              if (!result[value['group']]) {
                result[value['group']] = [];
              }
              result[value['group']].push({
                name: value['title'].replace(value['group'].toString().toLowerCase().trim(), ''),
                key: value['alias'] ? `#${value['alias']}#` : value['key'],
                valueType: value['valueType']
              });
            } else {
              if (!result['generic']) {
                result['generic'] = [];
              }
              result['generic'].push({
                name: value['title'],
                key: value['key'],
                valueType: value['valueType']
              });
            }
          });
          this.variables = result;
        }
      });

    this.campaignStore.pipe(select(getCampaigns))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(campaigns => {
        if (campaigns && campaigns.length > 0) {
          this.campaigns = campaigns;
        }
      });

    this.registrationPlatformStore.pipe(select(getRegistrationPlatforms))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(registrationPlatforms => {
        if (registrationPlatforms && registrationPlatforms.length > 0) {
          registrationPlatforms = JSON.parse(JSON.stringify(registrationPlatforms));
          this.registrationPlatforms = registrationPlatforms.map(platform => {
            let supportName = this.widgetSupportValues.filter(item => item.id === platform['widget_support']);
            platform['platform_name_with_support'] = `${platform['name']} ${supportName?.length ? ' : ' + supportName[0]['name'] : ''}`;
            return platform;
          });
          this.setWidgetCode();
        }
      });

    this.registrationPlatformStore.pipe(select(getProjectSuccessResponse))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(updateProject => {
        if (updateProject) {
          this.project = updateProject;
          setTimeout(() => {
          if (Number(this.selectedPlatform) !== this.projectRegistrationPlatformId && this.projectRegistrationPlatformId) {
            let reg_platform: any;
            reg_platform = this.registrationPlatforms.filter((item) => item.id === this.projectRegistrationPlatformId)[0];
            reg_platform =  JSON.parse(JSON.stringify(reg_platform));
            const project_ids = reg_platform.project_id ? reg_platform.project_id.split(',') : [];
            const projectIdList = project_ids.filter((item) => item !== this.projectId.toString());
            reg_platform['project_id'] = projectIdList.length > 0 ? projectIdList.toString() : '';
          }
          }, 500);

          setTimeout(() => {
            if (this.selectedPlatform) {
              let reg_platform: any;
              reg_platform = this.registrationPlatforms.filter((item) => item.id === Number(this.selectedPlatform))[0];
              reg_platform =  JSON.parse(JSON.stringify(reg_platform));
              const project_ids = reg_platform.project_id ? reg_platform.project_id.split(',') : [];
              if (!project_ids.includes(this.projectId.toString())) {
                reg_platform['project_id'] = reg_platform.project_id ? reg_platform.project_id.concat(',', this.projectId.toString()) : this.projectId.toString();
                this.projectRegistrationPlatformId = Number(this.selectedPlatform);
                this.getAllRegistrationPlatforms();
              }
            }
          }, 2000);
        }

    });

    this.projectStore.pipe(select(getProject))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(project => {
        if (project) {
          this.project = project;
          //console.log('--------project', project);
          this.ipLimitUrl = environment.frontUrl.replace('/#', '').replace(/\/+$/, '') + `/b/project/${this.project.code}/whitelist/auto_add_ip`;
          if (project.widget_settings) {
            this.projectMeta = (typeof project.widget_settings === 'string') ?
              JSON.parse(project.widget_settings) : _.cloneDeep(project.widget_settings);
            if(this.projectMeta['active'] && !this.projectMeta.hasOwnProperty('show_widget_ui_customization_on_all_widgets')) {
              this.projectMeta['show_widget_ui_customization_on_all_widgets'] = true;
            }
            if(!this.projectMeta.hasOwnProperty('language')) {
              this.projectMeta['language'] = 'en-us';
            }
            if (!this.projectMeta.hasOwnProperty('widget_version')) {
              this.projectMeta['widget_version'] = this.effectiveWidgetVersion;
            }
            for (const toggle of this.widgetBehaviorToggles) {
              if (!this.projectMeta.hasOwnProperty(toggle.key)) {
                this.projectMeta[toggle.key] = toggle.default;
              }
            }
            if (!this.projectMeta.hasOwnProperty('referral_append_query_string_to_all_links')) {
              this.projectMeta['referral_append_query_string_to_all_links'] = true;
            }
            if(!this.projectMeta.hasOwnProperty('widget_cdn_enabled')) {
              this.projectMeta['widget_cdn_enabled'] = false;
            }
            if (!['basic', 'authenticated'].includes(this.projectMeta['tiktok_share_method'])) {
              this.projectMeta['tiktok_share_method'] = 'basic';
            }
            this.projectMeta['registration_platform_default_custom_js'] = this.projectMeta['registration_platform_default_custom_js'] ?? false;
            this.projectMeta['registration_platform_default_custom_css'] = this.projectMeta['registration_platform_default_custom_css'] ?? false;
            this.projectPlatformId = this.projectMeta.hasOwnProperty('registration_platform_id') ? this.projectMeta['registration_platform_id'] : '';
            this.projectRegistrationPlatformId = this.projectPlatformId;
            this.selectedPlatform =  this.projectPlatformId ? this.projectPlatformId.toString() : '';

            if (!this.projectMeta.hasOwnProperty('custom_fields')) {
              this.projectMeta['custom_fields'] = JSON.parse(JSON.stringify(this.default_custom_fields));
            } else {
              const existingCustomFieldsMap = {};
              this.projectMeta['custom_fields'].forEach(field => {
                existingCustomFieldsMap[field.key] = field;
              });
              
              const normalizedCustomFields = this.default_custom_fields.map(defaultField => {
                if (existingCustomFieldsMap[defaultField.key]) {
                  return existingCustomFieldsMap[defaultField.key];
                }
                return JSON.parse(JSON.stringify(defaultField));
              });
              
              this.projectMeta['custom_fields'] = normalizedCustomFields;
            }

            if (!this.projectMeta.hasOwnProperty('allow_influencers_to_edit_primary_info')) {
              this.projectMeta['allow_influencers_to_edit_primary_info'] = false;
            }
            this.ensureWidgetAdvancedDefaults();
          if (!this.projectMeta.hasOwnProperty('allow_influencers_to_update_their_video_in_widget')) {
            this.projectMeta['allow_influencers_to_update_their_video_in_widget'] = false;
          }
            if (!Array.isArray(this.projectMeta['font_by_language'])) {
              this.projectMeta['font_by_language'] = [];
            }
            // A v1 project opened before the preserve-v1 sweep has reached it still holds
            // its source in the plain keys; stash it under _old here so the keyed editors
            // and the AI convert flow see the same code the widget serves.
            if (this.effectiveWidgetVersion === 'v1') {
              if (!this.projectMeta.hasOwnProperty('custom_script_old')) {
                this.projectMeta['custom_script_old'] = this.projectMeta['custom_script'] ?? null;
              }
              if (!this.projectMeta.hasOwnProperty('custom_css_old')) {
                this.projectMeta['custom_css_old'] = this.projectMeta['custom_css'] ?? null;
              }
            }
          } else {
            this.projectMeta = {
              active: false,
              enable_linkedin_integration_before_registration: false,
              language: 'en-us',
              header_1: '',
              header_2: '',
              header_3: '',
              custom_script: '',
              custom_css: '',
              widget_cdn_enabled: false,
              custom_fields: this.default_custom_fields,
              default_new_register_campaign_id: null,
              conditional_new_register_campaign_id: null,
              registration_platform_id: null,
              note: '',
              whitelist_access: false,
              auto_add_ip: false,
              limit_access_ips: '',
              referral_allowed_domains: '',
              remote_log_disabled: true,
              google_analytics_disabled: false,
              registration_platform_default_custom_css: true,
              registration_platform_default_custom_js: true,
              user_agreement_checkbox_disabled: false,
              show_preload: false,
              debug: false,
              allow_influencers_to_edit_primary_info: false,
              allow_influencers_to_update_their_video_in_widget: false,
              ...this.widgetAdvancedDefaults,
              font_by_language: [],
              discover_form_fields_detect_first_fields: true,
              discover_payment_form_fields_detect_first_fields: true,
              discover_promotion_form_fields_detect_first_fields: true,
              discover_form_fields_only_if_visible: false,
              discover_payment_form_fields_only_if_visible: false,
              discover_promotion_form_fields_only_if_visible: false,
              convert_name_to_first_name_last_name: true,
              show_widget_only_if_trigger_container_is_visible: true,
              referral_append_query_string_to_all_links: true,
            };
          }
          this.setWidgetCode();
          this.applyDefaultGlobalInheritance();
          this.refreshWidgetIntegrationUrl();

          if (this.project?.activation_ends_at && this.projectMeta['active']) {
            const currentDate = new Date();
            const activationEndDate = new Date(this.project.activation_ends_at);
            if (currentDate > activationEndDate) {
              this.toastr.warning('Project active time is expired and the widget as the result is no longer active.', 'Warning');
            }
          }
        }
      });

    this.templateStore.pipe(select(getWidgetIntegrationBody))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(widgetIntegrationBody => {
        if (widgetIntegrationBody) {
          this.widgetIntegrationBody = widgetIntegrationBody;
        }
      });

    this.templateStore.pipe(select(getWidgetIntegrationBodyError))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(error => {
        if (error) {
          this.widgetIntegrationBody = null;
          this.toastr.error(error, 'Error');
        }
      });

    this.templateStore.pipe(select(getWidgetCustomScriptBody))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(widgetCustomScriptBody => {
        if (widgetCustomScriptBody) {
          this.widgetCustomScriptBody = widgetCustomScriptBody;
        }
      });

    this.templateStore.pipe(select(getWidgetAvatarTemplates))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(widgetAvatarTemplates => {
        if (widgetAvatarTemplates && widgetAvatarTemplates.length > 0) {
          this.widgetAIAvatarTemplates = widgetAvatarTemplates.map((item) => ({
            ...item,
            selectedImageVariation: item.image_variations.find(image => image.isActive)
          }));

          this.selectedWidgetAIAvatarTemplate = (this.projectMeta.hasOwnProperty('widget_ai_avatar_template') && this.projectMeta['widget_ai_avatar_template']) ?
            this.widgetAIAvatarTemplates.find(item => item.id === this.projectMeta['widget_ai_avatar_template']) : null;
        }
      });

  }
  // templateSectionsubscribeStores()  {
  //   this.templateSectionStore.pipe(select(getTemplateSectionAssets))
  //     .pipe(takeUntil(this.unsubscriber))
  //     .subscribe(templateSectionAssets => {
  //       if (templateSectionAssets) {
  //         if (Object.keys(this.variables).length > 0) {
  //           this.enableEditor(templateSectionAssets.assets?.css);
  //         } else {
  //           setTimeout(() => {
  //             this.enableEditor(templateSectionAssets.assets?.css);
  //           }, 1000);
  //         }
  //       }
  //     });
  // }

  ngAfterViewInit() {
    this.editor?.getEditor().setOptions({
      showLineNumbers: true,
      tabSize: 2
    });
    // this.templateSectionStore.dispatch(TemplateSectionGetAssets({params: {html_mode: 'editor'}}));
    if (this.editor) this.editor.mode = 'javascript';
    this.cdr.detectChanges();
  }

  getAllRegistrationPlatforms() {
    const options = {widget_support: true};
    if (this.currentUser?.can('filter-platforms-by-project', 'project-ui')) {
      options['project_id'] = this.projectId;
    }

    this.registrationPlatformStore.dispatch(RegistrationPlatformList({
      params: {
        options: JSON.stringify(options),
      }
    }));
  }

  get remoteLogEnabled(): boolean {
    return !this.projectMeta['remote_log_disabled'];
  }

  set remoteLogEnabled(value: boolean) {
    this.projectMeta['remote_log_disabled'] = !value;
  }

  changeCheckBox(event) {
    this.projectMeta['whitelist_access'] = event.target.checked;
  }

  updateValue(variable, textFor) {
    const value = this.projectMeta[textFor] || '';
    const varValue = variable.key;
    this.projectMeta[textFor] = `${value} ${varValue}`;
  }

  onFileBrowserFieldSelected(url: string | null, fieldKey: string) {
    this.projectMeta[fieldKey] = url ?? '';
  }

  private loadProject(id) {
    this.projectStore.dispatch(ProjectGet({projectId: id}));
  }

  loadGlobalWidget() {
    if (!this.projectId) return;
    this.globalWidgetService.getForProject(Number(this.projectId))
      .pipe(takeUntil(this.unsubscriber)).subscribe({
      next: (response) => {
        this.globalWidget = response.data || null;
        this.applyDefaultGlobalInheritance();
        this.refreshWidgetIntegrationUrl();
      },
      error: () => {
        this.globalWidget = null;
      }
    });
  }

  private applyDefaultGlobalInheritance(): void {
    if (this.globalWidget
      && !Object.prototype.hasOwnProperty.call(
        this.projectMeta,
        'global_widget_inherited_settings'
      )) {
      this.projectMeta['global_widget_inherited_settings'] = [
        ...this.globalWidgetSettingKeys
      ];
    }
  }

  isGlobalSettingInherited(key: string): boolean {
    return !!this.globalWidget && (this.projectMeta?.['global_widget_inherited_settings'] || []).includes(key);
  }

  toggleGlobalSetting(key: string, inherited: boolean) {
    const keys = new Set(this.projectMeta?.['global_widget_inherited_settings'] || []);
    if (inherited) {
      keys.add(key);
    } else {
      keys.delete(key);
    }
    this.projectMeta['global_widget_inherited_settings'] = Array.from(keys);
  }

  getGlobalWidgetValueLabel(key: string): string {
    const value = this.getGlobalWidgetValue(key);

    if (!this.globalWidget) return 'Not set';
    if (key === 'registration_platform_id') {
      const platform = this.globalWidget.registration_platform
        || this.registrationPlatforms.find((item) => Number(item.id) === Number(value));
      return platform?.name || (value ? `#${value}` : 'None');
    }
    if (typeof value === 'boolean') return value ? 'ON' : 'OFF';
    if (value === null || value === undefined || value === '') return 'Not set';
    if (Array.isArray(value)) return value.length ? `${value.length} configured` : 'Not set';
    if (typeof value === 'object') return 'Configured';

    const label = String(value).replace(/_/g, ' ');
    return label.length > 60 ? `${label.slice(0, 57)}...` : label;
  }

  getGlobalWidgetValue(key: string): any {
    if (!this.globalWidget) return null;

    if (key === 'active' || key === 'registration_platform_id' || key === 'note') {
      return this.globalWidget[key];
    }

    let settings = this.globalWidget.widget_settings || {};
    if (typeof settings === 'string') {
      try {
        settings = JSON.parse(settings);
      } catch (e) {
        settings = {};
      }
    }
    return settings[key];
  }

  isGlobalWidgetRichTextValue(key: string): boolean {
    return ['header_1', 'header_2', 'header_3', 'promo_text'].includes(key);
  }

  hasGlobalWidgetRichTextValue(key: string): boolean {
    const value = this.getGlobalWidgetValue(key);
    return value !== null && value !== undefined && String(value).trim() !== '';
  }

  getGlobalWidgetFormattedValue(key: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(String(this.getGlobalWidgetValue(key) || ''));
  }

  shareWidgetPreview() {
    this.isWidgetSave = true;
    if (!this.projectMeta['default_new_register_campaign_id']) {
      this.toastr.warning('Please select a campaign', 'Warning');
      return;
    }
    if (!this.validateCustomCode()) {
      return;
    }
    if (!this.isGlobalSettingInherited('font_by_language') && this.hasDuplicateLanguageFonts()) {
      this.toastr.error('Each language can only have one font configuration.', 'Error');
      return;
    }
    this.projectMeta['global_widget_inherited_settings'] = (
      this.projectMeta['global_widget_inherited_settings'] || []
    ).filter((key) => this.globalWidgetSettingKeys.includes(key));
    let project = JSON.parse(JSON.stringify(this.project));
    if (this.projectMeta['registration_platform_id']  === null || this.projectMeta['registration_platform_id']  === '') {
      delete this.projectMeta.registration_platform_id;
    } else {
      this.isResetSelectPlatform = true;
    }

    project = {
      ...project,
      widget_settings: {...this.projectMeta}
    };
    this.projectStore.dispatch(ProjectUpdate({project, projectId: this.projectId}));
    this.projectPlatformId = this.projectMeta['registration_platform_id'];
  }

  validateCustomCode(): boolean {
    if (this.globalWidget) return true;
    const customScript = this.projectMeta[this.customScriptKey];
    if (customScript && typeof customScript === 'string' && customScript.trim()) {
      try {
        // eslint-disable-next-line no-new-func
        new Function(customScript);
      } catch (e) {
        this.toastr.error('Custom Script syntax error: ' + (e?.message || e), 'Error');
        return false;
      }
    }

    const customCss = this.projectMeta[this.customCssKey];
    if (customCss && typeof customCss === 'string' && customCss.trim()) {
      let depth = 0;
      for (const char of customCss) {
        if (char === '{') {
          depth++;
        } else if (char === '}') {
          depth--;
          if (depth < 0) {
            break;
          }
        }
      }
      if (depth !== 0) {
        this.toastr.error('Custom CSS syntax error: unbalanced braces', 'Error');
        return false;
      }
    }

    return true;
  }

  showWidgetInstructions(widgetInstructions) {
    const widgetActive = this.isGlobalSettingInherited('active')
      ? !!this.globalWidget?.active
      : this.projectMeta['active'] === true;
    if (widgetActive) {
      if (this.projectMeta['default_new_register_campaign_id']) {
        this.refreshWidgetIntegrationUrl();
        const modelRef = this._modalService.open(widgetInstructions, {
          centered: false,
          size: 'xl',
          keyboard: true
        });
        modelRef.result.then((result) => {
        }, (reason) => {
        });
        if (this.currentUser?.can( 'hide-platform-url', 'project-ui')) {
          setTimeout(() => {
            document.getElementsByClassName('platform-url')[0]?.remove();
          }, 500);
        }
      } else {
        this.toastr.warning('The widget is active but the settings are incorrect', 'Warning');
      }
    } else {
      this.toastr.warning('The widget is not active', 'Warning');
    }
  }

  showAddPlatformPopup() {
    this.entityFormModal.open('/settings/registration-platform/add');
  }

  showCustomScriptInstructions(modal) {
    const modelRef = this._modalService.open(modal, {
      centered: false,
      size: 'xl',
      keyboard: true
    });
    modelRef.result.then((result) => {
    }, (reason) => {
    });
    this.templateStore.dispatch(WidgetCustomScriptBody({version: this.effectiveWidgetVersion}));
  }

onSelectRegistrationPlatform(event) {
    this.projectMeta['registration_platform_id'] = event ? event.value : null;
    this.selectedPlatform = event ?  this.projectMeta['registration_platform_id'].toString() : '';
    this.setWidgetCode();
  }

  setWidgetCode() {
    const registrationPlatformId = Number(this.projectMeta['registration_platform_id']);
    if (registrationPlatformId) {
      this.registrationPlatforms.map((item) => {
        if (item.id === registrationPlatformId) {
          const oldSuffix = this.effectiveWidgetVersion === 'v1' ? '_old' : '';
          this.widgetCustomizationCode = item[`widget_customization_code${oldSuffix}`];
          this.widgetCustomizationCss = item[`widget_customization_css${oldSuffix}`];
          this.widgetIntegrationGuide = item.widget_integration_guide;
          this.platformName = item.name;
        }
      });
    }
  }

  previewWidget() {
    if (this.projectMeta['active']) {
      window.open(`/share/join/${this.project.code}`, '_blank');
    }
  }

  startWidgetIntegrationAssistantSession() {
    if (this.projectMeta['active']) {
      window.open(`/share/start-integration-session/${this.project.code}`, '_blank');
    }
  }

  copyProjectCode(code) {
    const input = document.createElement('textarea');
    input.value = code;
    document.body.appendChild(input);
    input.select();
    document.execCommand('Copy');
    this.toastr.success('Project Code is Copied');
    input.remove();
  }

  onclickWidgetGuide() {
    const platformId = this.projectMeta['registration_platform_id'];
    this.registrationPlatformService.previewUrl(platformId).pipe(takeUntil(this.unsubscriber)).subscribe(response => {
      if (response['success']) {
        window.open(response['data'].url, '_blank');
      }
      });
  }

  showCustomizeAvatarTemplatePopup() {
    this.cdr.detectChanges();
    const data = {
      project_id: this.projectId
    };
    const modelRef: any = this._modalService.open(WidgetAvatarTemplatesComponent, {
      centered: false,
      size: 'xl',
      keyboard: true
    });
    modelRef.componentInstance.data = data;
    modelRef.result.then((result) => {
    }, (reason) => {
      this.fetchWidgetAITemplates()
    });
  }

  fetchWidgetAITemplates() {
    const orderBy = {'column': 'created_at', 'dir': 'desc'};
    let options = {orderBy};
    setTimeout(() => {
      this.templateStore.dispatch(WidgetAvatarTemplateListAll({
        params: {
          options: JSON.stringify(options),
          project_id: this.projectId,
        }
      }));
    }, 500);
  }

  selectWidgetAIAvatarTemplate(template) {
    this.projectMeta['widget_ai_avatar_template'] = template.id;
    this.selectedWidgetAIAvatarTemplate = template;
  }

  dropCustomField(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.projectMeta.custom_fields, event.previousIndex, event.currentIndex);
  }

  ngOnDestroy() {
    window.removeEventListener('message', this.handleFontBrowserMessage);
    this.unsubscriber.next(undefined);
    this.unsubscriber.complete();
  }


  get languageFonts(): any[] {
    if (!Array.isArray(this.projectMeta?.['font_by_language'])) {
      this.projectMeta['font_by_language'] = [];
    }
    return this.projectMeta['font_by_language'];
  }

  addLanguageFont() {
    this.languageFonts.push({ language: null, font_family: '' });
  }

  removeLanguageFont(index: number) {
    this.languageFonts.splice(index, 1);
  }

  /** Languages already claimed by another row, so the picker can grey them out. */
  languageFontTakenBy(index: number): string[] {
    return this.languageFonts
      .filter((entry, i) => i !== index && entry?.language)
      .map((entry) => entry.language);
  }

  isDuplicateLanguageFont(index: number): boolean {
    const language = this.languageFonts[index]?.language;
    return !!language && this.languageFontTakenBy(index).includes(language);
  }


  hasDuplicateLanguageFonts(): boolean {
    return this.languageFonts.some((_, index) => this.isDuplicateLanguageFont(index));
  }

  getWidgetTextEditorConfig(key: string) {
    return ['header_1', 'header_2', 'header_3'].includes(key)
      ? this.widgetHeaderTextEditorConfig
      : this.widgetTextEditorConfig;
  }

  onWidgetTextEditorChange(key: string, value: string) {
    if (!this.projectMeta['active'] || this.isGlobalSettingInherited(key)) {
      return;
    }
    this.projectMeta[key] = value || '';
  }

  onWidgetTextEditorVariableClick(variable, key: string, editorComponent = null) {
    if (!this.projectMeta['active'] || this.isGlobalSettingInherited(key)) {
      return;
    }

    const editor = editorComponent?.instance;
    if (editor?.insertText) {
      editor.focus();
      editor.insertText(variable.key);
      this.projectMeta[key] = editor.getData();
      return;
    }

    this.projectMeta[key] = `${this.projectMeta[key] || ''}${variable.key}`;
  }

  onWidgetTextEditorFileSelected(url: string | null, key: string) {
    if (!this.projectMeta['active'] || this.isGlobalSettingInherited(key)) {
      return;
    }
    this.projectMeta[key] = url ?? '';
  }

  configureWidgetTextEditorOutput(event) {
    configureSharedWidgetTextEditorOutput(event);
  }


  private refreshWidgetIntegrationUrl(): void {
    if (!this.project?.code) return;
    const query = new URLSearchParams();
    query.set(
      'campaign_id',
      String(this.projectMeta?.['default_new_register_campaign_id'] || 0)
    );
    query.set('platform_id', String(this.getInstructionPlatformId() || 0));
    const baseUrl = environment.frontUrl.replace('/#', '').replace(/\/+$/, '');
    this.shareWidgetLinkUrl = `${baseUrl}/b/project/${this.project.code}`
      + `/widget_integration_instruction?${query.toString()}`;
    this.widgetIntegrationUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.shareWidgetLinkUrl
    );
    this.cdr.detectChanges();
  }

  configureWidgetTextEditorNamespace(ckEditor) {
    configureSharedWidgetTextEditorNamespace(ckEditor);
  }


  private getInstructionPlatformId(): number | null {
    if (this.globalWidget) {
      return Number(this.globalWidget.registration_platform_id) || null;
    }
    return Number(this.projectMeta?.['registration_platform_id']) || null;
  }


  get effectiveWidgetVersion(): 'v1' | 'v2' {
    const projectVersion = this.projectMeta?.['widget_version'];
    if (projectVersion === 'v1' || projectVersion === 'v2') {
      return projectVersion;
    }
    const resolvedProjectVersion = this.project?.widget_version;
    if (resolvedProjectVersion === 'v1' || resolvedProjectVersion === 'v2') {
      return resolvedProjectVersion;
    }
    let clientSettings = this.project?.client?.client_settings || {};
    if (typeof clientSettings === 'string') {
      try {
        clientSettings = JSON.parse(clientSettings);
      } catch (e) {
        clientSettings = {};
      }
    }
    return clientSettings.widget_version === 'v2' ? 'v2' : 'v1';
  }

  get customScriptKey(): string {
    return this.effectiveWidgetVersion === 'v1' ? 'custom_script_old' : 'custom_script';
  }

  get customCssKey(): string {
    return this.effectiveWidgetVersion === 'v1' ? 'custom_css_old' : 'custom_css';
  }

  get hasLegacyWidgetCustomization(): boolean {
    return !!(
      String(this.projectMeta?.['custom_script_old'] || '').trim()
      || String(this.projectMeta?.['custom_css_old'] || '').trim()
    );
  }

  get canGenerateWidgetCustomization(): boolean {
    return !!this.currentUser?.can('generate-widget-customization', 'project-ui');
  }

  openWidgetCustomizationAi(): void {
    if (!this.canGenerateWidgetCustomization) return;
    const modalRef = this._modalService.open(WidgetCustomizationAiModalComponent, {
      centered: false,
      size: 'xl',
      keyboard: false,
      backdrop: 'static'
    });
    const component = modalRef.componentInstance as WidgetCustomizationAiModalComponent;
    component.projectId = Number(this.projectId);
    component.registrationPlatformId = this.projectMeta?.['registration_platform_id']
      ? Number(this.projectMeta['registration_platform_id'])
      : null;
    component.currentScript = this.projectMeta?.[this.customScriptKey] || '';
    component.currentCss = this.projectMeta?.[this.customCssKey] || '';
    component.hasLegacyCustomization = this.hasLegacyWidgetCustomization;
    component.initialize();

    modalRef.result.then((result: WidgetCustomizationAiResult) => {
      const scriptKey = result.target_widget_version === 'v1'
        ? 'custom_script_old'
        : 'custom_script';
      const cssKey = result.target_widget_version === 'v1'
        ? 'custom_css_old'
        : 'custom_css';
      this.projectMeta[scriptKey] = result.custom_script;
      this.projectMeta[cssKey] = result.custom_css;
    }).catch(() => {});
  }


  @ViewChild('fontFileBrowser') fontFileBrowser?: FileBrowserComponent;

  @ViewChild('fontBrowserShell') fontBrowserShell?: IframeModalShellComponent;

  fontBrowserUrl: SafeResourceUrl | null = null;

  fontBrowserModalRef: NgbModalRef | null = null;

  activeVideoCaptionFontSettingsTarget: any = null;

  widgetAdvancedDefaults = {
    widget_profile_picture_min_width: 0,
    widget_profile_picture_min_height: 10,
    widget_profile_video_enable_recorder: true,
    widget_profile_video_min_duration: 0,
    widget_profile_video_max_duration: 10,
    widget_profile_video_min_width: 0,
    widget_profile_video_min_height: 0,
    widget_profile_video_target_aspect_width: 0,
    widget_profile_video_target_aspect_height: 0,
    widget_profile_video_caption_mode: 'let_user_decide',
    widget_profile_video_caption_let_user_decide: true,
    widget_profile_video_caption_position: 'bottom',
    widget_profile_video_caption_background_enabled: true,
    widget_profile_video_caption_background_color: '#FFFFFF',
    widget_profile_video_caption_background_opacity: 50,
    widget_profile_video_caption_font_color: '#000000',
    widget_profile_video_caption_font_opacity: 50,
    widget_profile_video_caption_font_family: '',
    widget_profile_video_caption_font_face: '',
    widget_profile_video_caption_font_url: '',
    widget_profile_video_background_mode: 'let_user_decide',
    widget_profile_video_background_let_user_decide: true,
    widget_profile_video_background_color: '#FFFFFF',
    widget_profile_video_enable_teleprompter: true,
    widget_profile_video_teleprompter_speed: 500,
    widget_profile_video_teleprompter_question: ''
  };

  openVideoCaptionFontBrowser(settingsTarget: any, template: any) {
    this.activeVideoCaptionFontSettingsTarget = settingsTarget;
    const theme = document.body.classList.contains('dark-theme') ? 'dark' : 'light';
    const appContext = { token: this.token, projectId: this.projectId || null };
    const url = `${environment.apiUrl}/share/font-browser/show?appcontext=${encodeURIComponent(JSON.stringify(appContext))}&theme=${theme}&requireRemoteFont=true`;
    this.fontBrowserUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.fontBrowserModalRef = this._modalService.open(template, {
      centered: false,
      size: 'xl',
      keyboard: true,
      windowClass: 'widget-font-browser-modal'
    });
  }

  onFontBrowserFileSelected(url: string | null) {
    if (!url) {
      return;
    }

    const message = {
      origin: 'parent',
      action: 'fontFileSelected',
      url
    };
    const iframeWindow =
      this.fontBrowserShell?.iframe?.nativeElement?.contentWindow ||
      (document.querySelector('.widget-font-browser-modal iframe') as HTMLIFrameElement | null)?.contentWindow;
    iframeWindow?.postMessage(message, '*');
  }

  getVideoCaptionFontLabel(settingsTarget: any) {
    const savedName = settingsTarget?.['widget_profile_video_caption_font_family'];
    if (savedName) {
      return savedName;
    }

    return 'Default caption font';
  }

  clearVideoCaptionFont(settingsTarget: any) {
    settingsTarget['widget_profile_video_caption_font_family'] = '';
    settingsTarget['widget_profile_video_caption_font_face'] = '';
    settingsTarget['widget_profile_video_caption_font_url'] = '';
  }

  openWidgetAdvancedSettings(template: any) {
    this.settingsService.getSettingByKey(WIDGET_MEDIA_ADVANCED_DEFAULTS_SETTING_KEY)
      .pipe(takeUntil(this.unsubscriber))
      .subscribe((response: any) => {
        this.applyWidgetAdvancedDefaultSettings(response?.data?.value);
        this.openWidgetAdvancedSettingsModal(template);
      }, () => {
        this.ensureWidgetAdvancedDefaults();
        this.openWidgetAdvancedSettingsModal(template);
      });
  }

  saveWidgetAdvancedSettings(modal: any) {
    this.ensureWidgetAdvancedDefaults();
    modal.close();
  }

  private loadWidgetAdvancedDefaultSettings() {
    this.settingsService.getSettingByKey(WIDGET_MEDIA_ADVANCED_DEFAULTS_SETTING_KEY)
      .pipe(takeUntil(this.unsubscriber))
      .subscribe((response: any) => {
        this.applyWidgetAdvancedDefaultSettings(response?.data?.value);
      }, () => {});
  }

  private openWidgetAdvancedSettingsModal(template: any) {
    this._modalService.open(template, {
      centered: true,
      keyboard: true,
      scrollable: true,
      windowClass: 'widget-advanced-settings-window'
    });
  }

  private applyWidgetAdvancedDefaultSettings(value: any) {
    const defaults = this.flattenWidgetAdvancedDefaults(value);
    if (Object.keys(defaults).length > 0) {
      this.widgetAdvancedDefaults = {
        ...this.widgetAdvancedDefaults,
        ...defaults
      };
    }
    this.ensureWidgetAdvancedDefaults();
  }

  private flattenWidgetAdvancedDefaults(value: any) {
    if (!value) {
      return {};
    }

    let parsed = value;
    if (typeof parsed === 'string') {
      try {
        parsed = JSON.parse(parsed);
      } catch (e) {
        return {};
      }
    }

    return {
      ...(parsed.image || {}),
      ...(parsed.video || {})
    };
  }

  private ensureWidgetAdvancedDefaults() {
    if (!this.projectMeta) {
      this.projectMeta = {};
    }
    if (
      !Object.prototype.hasOwnProperty.call(this.projectMeta, 'widget_profile_picture_min_height') &&
      Object.prototype.hasOwnProperty.call(this.projectMeta, 'widget_profile_picture_max_height')
    ) {
      this.projectMeta['widget_profile_picture_min_height'] = this.projectMeta['widget_profile_picture_max_height'];
    }
    Object.keys(this.widgetAdvancedDefaults).forEach(key => {
      const defaultValue = this.widgetAdvancedDefaults[key as keyof typeof this.widgetAdvancedDefaults];
      if (!Object.prototype.hasOwnProperty.call(this.projectMeta, key)) {
        this.projectMeta[key] = defaultValue;
      }
    });
    delete this.projectMeta['widget_profile_picture_max_height'];
    if (
      !(Number(this.projectMeta['widget_profile_video_min_height']) > 0) &&
      Object.prototype.hasOwnProperty.call(this.projectMeta, 'widget_profile_video_max_height')
    ) {
      this.projectMeta['widget_profile_video_min_height'] = this.projectMeta['widget_profile_video_max_height'];
    }
    this.projectMeta['widget_profile_video_caption_mode'] = this.normalizeWidgetVideoMode(
      this.projectMeta['widget_profile_video_caption_mode'],
      this.projectMeta['widget_profile_video_caption_let_user_decide']
    );
    this.projectMeta['widget_profile_video_caption_position'] = this.normalizeWidgetCaptionPosition(
      this.projectMeta['widget_profile_video_caption_position']
    );
    this.projectMeta['widget_profile_video_caption_background_enabled'] = this.normalizeWidgetBoolean(
      this.projectMeta['widget_profile_video_caption_background_enabled']
    );
    this.projectMeta['widget_profile_video_background_mode'] = this.normalizeWidgetVideoMode(
      this.projectMeta['widget_profile_video_background_mode'],
      this.projectMeta['widget_profile_video_background_let_user_decide']
    );
    this.projectMeta['widget_profile_video_caption_let_user_decide'] = false;
    this.projectMeta['widget_profile_video_background_let_user_decide'] = false;
  }

  private handleFontBrowserMessage = (event: MessageEvent) => {
    const data = typeof event.data === 'string' ? this.tryParseMessageData(event.data) : event.data;
    if (!data || data.origin !== 'fontBrowser') {
      return;
    }

    this.ngZone.run(() => {
      if (data.action === 'fontSelected') {
        this.applyVideoCaptionFontSelection(data);
        this.fontBrowserModalRef?.close();
        this.fontBrowserModalRef = null;
        this.activeVideoCaptionFontSettingsTarget = null;
      } else if (data.action === 'openFileBrowser') {
        this.fontFileBrowser?.openFileBrowser();
      }
    });
  };

  private applyVideoCaptionFontSelection(data: any) {
    const fontName = `${data.fontFamily || ''}`.trim();
    const target = this.activeVideoCaptionFontSettingsTarget || this.projectMeta;
    if (!fontName || !target) {
      return;
    }

    const fontFace = `${data.fontFace || data.fontStyle || ''}`.trim();
    const fontUrl = this.getFontUrlFromFontFace(fontFace);
    if (fontFace && !fontUrl) {
      this.toastr.warning('This font is only available on your computer. Upload a woff/woff2 font or choose a web font so saved videos can render it.', 'Font not available for server render');
      return;
    }

    target['widget_profile_video_caption_font_family'] = fontName;
    target['widget_profile_video_caption_font_face'] = fontFace;
    target['widget_profile_video_caption_font_url'] = fontUrl;
  }

  private getFontUrlFromFontFace(fontFace: string) {
    const match = `${fontFace || ''}`.match(/url\((['"]?)(.*?)\1\)/i);
    return match?.[2] || '';
  }

  private tryParseMessageData(raw: string) {
    try {
      const parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : null;
    } catch (e) {
      return null;
    }
  }

  private normalizeWidgetVideoMode(value: any, letUserDecide: any) {
    if (letUserDecide === true || letUserDecide === 'true' || letUserDecide === 1 || letUserDecide === '1') {
      return 'let_user_decide';
    }

    const normalized = `${value || ''}`.toLowerCase();
    if (normalized === 'let_user_decide') {
      return 'let_user_decide';
    }
    if (['disabled', 'off', 'none', 'false'].includes(normalized)) {
      return 'disabled';
    }
    return 'auto';
  }

  private normalizeWidgetCaptionPosition(value: any) {
    const normalized = `${value || ''}`.toLowerCase();
    return ['top', 'center', 'bottom'].includes(normalized) ? normalized : 'bottom';
  }

  private normalizeWidgetBoolean(value: any) {
    if (typeof value === 'boolean') {
      return value;
    }
    if (typeof value === 'number') {
      return value !== 0;
    }
    if (typeof value === 'string') {
      return ['true', '1', 'on', 'yes'].includes(value.trim().toLowerCase());
    }
    return !!value;
  }
}
